"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewContentCommand = void 0;
class ViewContentCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { content_category, content_name, viewType, value, currency, contents, content_type } = this.input;
        const { fbq: facebookQueue } = config;
        if (viewType === 'ViewContent') {
            const object = {
                content_ids: [contents?.[0]?.id ?? 'no-id-view-content'],
                value: value,
                currency: currency,
                content_type: content_type ?? 'product',
                content_name: content_name,
            };
            facebookQueue('track', 'ViewContent', object);
            facebookQueue('trackCustom', 'ViewContentWeb', object);
        }
        else {
            const object = {
                content_name: content_name,
                content_category: content_category,
                content_ids: (contents ?? []).map((content) => `${content.id}`),
                content_type: content_type ?? 'product',
            };
            facebookQueue('trackCustom', 'ViewCategory', object);
            facebookQueue('trackCustom', 'ViewCategoryWeb', object);
        }
        return Promise.resolve();
    }
}
exports.ViewContentCommand = ViewContentCommand;
